export interface ProviderCreditIssue { provider:'anthropic'|'openrouter'|'meshy'|'runware'; message:string }
export const PROVIDER_CREDIT_EVENT='lumnos:provider-credit-exhausted';
export const providerNames={anthropic:'Claude',openrouter:'OpenRouter',meshy:'Meshy',runware:'Runware'};
export function isProviderCreditIssue(issue:any):issue is ProviderCreditIssue {return !!issue&&Object.hasOwn(providerNames,issue.provider)&&typeof issue.message==='string';}
export function showProviderCreditPrompt(issue:ProviderCreditIssue,key?:string) {
  if(isProviderCreditIssue(issue))window.dispatchEvent(new CustomEvent(PROVIDER_CREDIT_EVENT,{detail:{issue,key}}));
}
